import ClientId from '~/constants/ClientId';

const ClientIdToNativeAppNameMap: Partial<Record<ClientId, string>> = {
  [ClientId.HOME_UI]: 'Home',
  [ClientId.SRP_UI]: 'SRP',
  [ClientId.VDP_UI]: 'VDP'
};

export function getAppCapabilitiesCookieName(clientId: ClientId) {
  return `X-CVNA-AppCapabilities-${ClientIdToNativeAppNameMap[clientId]}`;
}
